module.exports = __webpack_public_path__ + "static/media/snowy-2.d103c77c.svg";